import { httpCall, httpFetch, formatEpochDateTime } from "../../common/util";
import * as qs from 'qs';
import HeaderActionApiMapping from "./actionURLMapping";
import { getAuthHeaders } from "@/utils/authManager";
import config from "../WorkkardDetail/endpoints";
const ep = config.api.endpoints

export const getSessionContextInfo = (ActionType, payload) => {
  return httpCall({
    method: HeaderActionApiMapping[ActionType].method,
    headers: {
      "Content-Type": "application/json"
    },
    params: payload,
    url: HeaderActionApiMapping[ActionType].url
  });
};

export const getAssociatedParties = (ActionType, payload ) => {
    return httpCall({
      method: HeaderActionApiMapping[ActionType].method,
      headers: {
        "Content-Type": "application/json"
      },
      params: payload,
      url: HeaderActionApiMapping[ActionType].url
    });
  };

  export const getOrgAccess = (ActionType, payload ) => {
    return httpCall({
      method: HeaderActionApiMapping[ActionType].method,
      headers: {
        "Content-Type": "application/json"
      },
      params: payload,
      url: HeaderActionApiMapping[ActionType].url
    });
  };

  export const updateOrgAccess = (ActionType, payload ) => {
    payload = Object.assign({}, payload, { '__RequestVerificationToken': $('input[name="__RequestVerificationToken"]')[0].value || "" })
    return fetch(HeaderActionApiMapping[ActionType].url, {
      method: HeaderActionApiMapping[ActionType].method,
      credentials: "include",
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'cache-control': 'no-cache', 'pragma': 'no-cache' },
      body: qs.stringify(payload)
    })
      .then(response => response.json());
  };

  export const fetchPartyStates = (ActionType, payload ) => {
    return httpCall({
      method: HeaderActionApiMapping[ActionType].method,
      headers: {
        "Content-Type": "application/json"
      },
      params: payload,
      url: HeaderActionApiMapping[ActionType].url
    });
  };
  
  export const fetchPartyInfo = (ActionType, payload ) => {
    return httpCall({
      method: HeaderActionApiMapping[ActionType].method,
      headers: {
        "Content-Type": "application/json"
      },
      params: payload,
      url: HeaderActionApiMapping[ActionType].url
    });
  };
  
  export const fetchPartySuggestions = (ActionType, payload ) => {
    return httpCall({
      method: HeaderActionApiMapping[ActionType].method,
      headers: {
        "Content-Type": "application/json"
      },
      params: payload,
      url: HeaderActionApiMapping[ActionType].url
    });
  };
  
  export const addAssociateParty = (ActionType, payload ) => {
    payload = Object.assign({}, payload, { '__RequestVerificationToken': $('input[name="__RequestVerificationToken"]')[0].value || "" })
    return fetch(HeaderActionApiMapping[ActionType].url, {
      method: HeaderActionApiMapping[ActionType].method,
      credentials: "include",
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'cache-control': 'no-cache', 'pragma': 'no-cache' },
      body: qs.stringify(payload)
    })
      .then(response => response.json());
  };
  
  export const deleteAssociateParty = (ActionType, payload ) => {
    payload = Object.assign({}, payload, { '__RequestVerificationToken': $('input[name="__RequestVerificationToken"]')[0].value || "" })
    return fetch(HeaderActionApiMapping[ActionType].url, {
      method: HeaderActionApiMapping[ActionType].method,
      credentials: "include",
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'cache-control': 'no-cache', 'pragma': 'no-cache' },
      body: qs.stringify(payload)
    })
      .then(response => response.json());
  };

export const getPanelFilterSettings = (ActionType, payload ) => {
  return httpCall({
    method: HeaderActionApiMapping[ActionType].method,
    headers: {
      "Content-Type": "application/json"
    },
    params: payload,
    url: HeaderActionApiMapping[ActionType].url
  });
};

const buildNotificationUrls = (item) => {
  const subDomain = item.SubDomain || '';
  const contractId = item.ContractId != null ? item.ContractId : 0;
  return {
    UnAssignedActivityUrl: `${subDomain}/activities?st=unassigned`,
    UnAssignedWorkkardUrl: `${subDomain}/workkards?st=unassigned`,
    WorkkardNoteDetailUrl: `${subDomain}/getclmdetail?cId=${item.WorkkardId}&id=${item.NoteId}#cun`,
    ActivityNoteDetailUrl: `${subDomain}/gad?actId=${item.ActivityId}&id=${item.NoteId}#aun`,
    RedirectUrl: `${subDomain}/gtcmptqry?un=${item.HistoryId}`,
    B2BUrl: item.B2BId ? `${subDomain}/managecontract?id=${item.B2BId}&orgId=${item.B2BOrgId}&cId=${contractId}` : '',
    WorkkardDetailUrl: `${subDomain}/getclmdetail?cId=${item.WorkkardId}`,
    ActivityDetailUrl: `${subDomain}/getclmdetail?cId=${item.WorkkardId}&actId=${item.ActivityId}`
  };
};

const mapNotificationFields = (item) => {
  if (!item) return item;
  const createdDateEpoch = item.CreatedDate ? new Date(item.CreatedDate).getTime() : null;
  return {
    ...item,
    TriggeredByFullName: item.TriggeredByName,
    TriggeredByOrganisationNameFull: item.TriggeredByOrganisationName,
    WorkkardNo: item.RecentNotification ? item.RecentNotification.WorkkardNo : item.WorkkardNo,
    WorkkardNoFull: item.WorkkardNo,
    ActivityTitleFull: item.ActivityTitle,
    CreatedDate: createdDateEpoch ? formatEpochDateTime(createdDateEpoch) : item.CreatedDate,
    ...buildNotificationUrls(item)
  };
};

const mapNotificationItem = (item) => {
  const mapped = mapNotificationFields(item);
  if (item.RecentNotification) {
    mapped.RecentNotification = mapNotificationFields(item.RecentNotification);
  }
  return mapped;
};

export const getNotificationData = (payload) => {
  const params = {
    workkard_id: payload.wkId,
    status: payload.status,
    skip: payload.skip,
    take: payload.take,
    asc: payload.sortOrder === 'a'
  };
  if (!payload.wkId) {
    params.group_by_workkard = payload.isGroupByEnabled === true;
  }
  return httpCall({
    method: 'GET',
    headers: {
      "Content-Type": "application/json"
    },
    params,
    url: "/1.0/notification/data"
  }).then((response) => {
    const items = Array.isArray(response) ? response : (response && Array.isArray(response.Data) ? response.Data : null);
    if (!items) return response;
    const mapped = { status: 200, Data: items.map(mapNotificationItem) };
    return mapped;
  });
};

export const getUpdates = (ActionType, payload ) => {
  return httpCall({
    method: HeaderActionApiMapping[ActionType].method,
    headers: {
      "Content-Type": "application/json"
    },
    params: payload,
    url: HeaderActionApiMapping[ActionType].url
  });
};

export const getWorkkardUpdates = (ActionType, payload ) => {
  return httpCall({
    method: HeaderActionApiMapping[ActionType].method,
    headers: {
      "Content-Type": "application/json"
    },
    params: payload,
    url: HeaderActionApiMapping[ActionType].url
  });
};

export const updatePanelFilterSettings= (ActionType, payload ) => {
  return httpFetch({
    url: HeaderActionApiMapping[ActionType].url,
    method: HeaderActionApiMapping[ActionType].method,
    credentials: "include",
    data: payload
})
};

export const getOlderUpdates = (ActionType, payload ) => {
  return httpCall({
    method: HeaderActionApiMapping[ActionType].method,
    headers: {
      "Content-Type": "application/json"
    },
    params: payload,
    url: HeaderActionApiMapping[ActionType].url
  });
};

export const updateNotificationStatus = (payload) => {
  const data = payload.ids != null
    ? { ids: payload.ids, Status: payload.status }
    : payload.activity_id != null
    ? { activity_id: payload.activity_id, Status: payload.status }
    : { workkard_id: payload.workkard_id ?? 0, Status: payload.status };
  if (payload.updated != null) {
    data.updated = payload.updated;
  }
  return httpCall({
    method: 'PUT',
    headers: {
      "Content-Type": "application/json"
    },
    data,
    url: "/1.0/notification/updates"
  });
};

export const changeGroupUpdatesApi= (ActionType, payload ) => {
  return httpFetch({
    url: HeaderActionApiMapping[ActionType].url,
    method: HeaderActionApiMapping[ActionType].method,
    credentials: "include",
    data: payload
})
};
export const resetWorkkardGroupCounter= (ActionType, payload ) => {
  return httpFetch({
    url: HeaderActionApiMapping[ActionType].url,
    method: HeaderActionApiMapping[ActionType].method,
    credentials: "include",
    data: payload
})
};

export const updateGroupWorkkardSetting = (ActionType, payload ) => {
  return httpFetch({
    url: HeaderActionApiMapping[ActionType].url,
    method: HeaderActionApiMapping[ActionType].method,
    credentials: "include",
    data: payload
})
};

export const changeActivityUpdatesStatus= (ActionType, payload ) => {
  return httpFetch({
    url: HeaderActionApiMapping[ActionType].url,
    method: HeaderActionApiMapping[ActionType].method,
    credentials: "include",
    data: payload
})
};

export const getWorkkardAuStatus = (ActionType,payload) => {
  return httpCall({
    method: HeaderActionApiMapping[ActionType].method,
    headers: {
      "Content-Type": "application/json"
    },
    params: payload,
    url: HeaderActionApiMapping[ActionType].url
  });
}

export const getAUCounts= (ActionType,payload) => {
  return httpCall({
    method: HeaderActionApiMapping[ActionType].method,
    headers: {
      "Content-Type": "application/json"
    },
    params: payload,
    url: HeaderActionApiMapping[ActionType].url
  });
}

export const updateRecentWorkkardNotifStatus = (ActionType) => {
  return httpFetch({
    url: HeaderActionApiMapping[ActionType].url,
    method: HeaderActionApiMapping[ActionType].method,
    credentials: "include"
  })
}

export const getWorkkardSearchListApi = (ActionType, payload ) => {
  return httpCall({
    method: HeaderActionApiMapping[ActionType].method,
    headers: {
      "Content-Type": "application/json"
    },
    params: {
      query: payload.q
    },
    url: HeaderActionApiMapping[ActionType].url
  });
};

export const getRecentSearchListApi = (ActionType,payload) => {
  return httpCall({
    method: HeaderActionApiMapping[ActionType].method,
    headers: {
      "Content-Type": "application/json"
    },
    params: payload,
    url: HeaderActionApiMapping[ActionType].url
  });
}

export const removeRecentSearchItemApi = (ActionType,payload)=>{
  return httpFetch({
    url: HeaderActionApiMapping[ActionType].url,
    method: HeaderActionApiMapping[ActionType].method,
    credentials: "include",
    data: payload
  });
}

export const fetchWorkkardSearchResultDataApi = (ActionType,payload)=>{
  return httpCall({
    method: HeaderActionApiMapping[ActionType].method,
    headers: {
      "Content-Type": "application/json"
    },
    params: payload,
    url: HeaderActionApiMapping[ActionType].url
  });
}

export const fetchActivitySearchResultDataApi = (ActionType,payload)=>{
  return httpCall({
    method: HeaderActionApiMapping[ActionType].method,
    headers: {
      "Content-Type": "application/json"
    },
    params: payload,
    url: HeaderActionApiMapping[ActionType].url
  });
}

export const fetchNotesSearchResultDataApi = (ActionType,payload)=>{
  return httpCall({
    method: HeaderActionApiMapping[ActionType].method,
    headers: {
      "Content-Type": "application/json"
    },
    params: payload,
    url: HeaderActionApiMapping[ActionType].url
  });
}

export const fetchFilesSearchResultApi = (ActionType,payload)=>{
  return httpCall({
    method: HeaderActionApiMapping[ActionType].method,
    headers: {
      "Content-Type": "application/json"
    },
    params: payload,
    url: HeaderActionApiMapping[ActionType].url
  });
}

export const fetchActivityOwnerSearchResultDataApi = (ActionType,payload)=>{
  return httpCall({
    method: HeaderActionApiMapping[ActionType].method,
    headers: {
      "Content-Type": "application/json"
    },
    params: payload,
    url: HeaderActionApiMapping[ActionType].url
  });
}


export const fetchActivityAssigneeSearchResultDataApi = (ActionType,payload)=>{
  return httpCall({
    method: HeaderActionApiMapping[ActionType].method,
    headers: {
      "Content-Type": "application/json"
    },
    params: payload,
    url: HeaderActionApiMapping[ActionType].url
  });
}

export const fetchWorkkardOwnerSearchResultDataApi = (ActionType,payload)=>{
  return httpCall({
    method: HeaderActionApiMapping[ActionType].method,
    headers: {
      "Content-Type": "application/json"
    },
    params: payload,
    url: HeaderActionApiMapping[ActionType].url
  });
}

export const addglobalsearchusageApi = (ActionType,payload)=>{
  return httpFetch({
    url: HeaderActionApiMapping[ActionType].url,
    method: HeaderActionApiMapping[ActionType].method,
    credentials: "include",
    data: payload
})
}

export const getTopbarTabsCount = (ActionType, payload) => {
  return httpCall({
    method: HeaderActionApiMapping[ActionType].method,
    headers: {
      "Content-Type": "application/json"
    },
    params: payload,
    url: HeaderActionApiMapping[ActionType].url
  });
}

export const updateUserTheme = (ActionType, payload ) => {
  payload = Object.assign({}, payload, { '__RequestVerificationToken': $('input[name="__RequestVerificationToken"]')[0].value || "" })
  return fetch(HeaderActionApiMapping[ActionType].url, {
    method: HeaderActionApiMapping[ActionType].method,
    credentials: "include",
    headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'cache-control': 'no-cache', 'pragma': 'no-cache' },
    body: qs.stringify(payload)
  })
    .then(response => response.json());
}

export const fetchUserOrgNameSuggestions = (ActionType, payload) => {
  return httpCall({
    method: HeaderActionApiMapping[ActionType].method,
    headers: {
      "Content-Type": "application/json"
    },
    params: payload,
    url: HeaderActionApiMapping[ActionType].url
  });
}

export const fetchLeftNavigation = (ActionType, payload) => {
  return httpCall({
    method: HeaderActionApiMapping[ActionType].method,
    headers: {
      "Content-Type": "application/json"
    },
    params: payload,
    url: HeaderActionApiMapping[ActionType].url
  });
}

export const updateLayoutSetting = (ActionType, payload ) => {
  payload = Object.assign({}, payload, { '__RequestVerificationToken': $('input[name="__RequestVerificationToken"]')[0].value || "" })
  return fetch(HeaderActionApiMapping[ActionType].url, {
    method: HeaderActionApiMapping[ActionType].method,
    credentials: "include",
    headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'cache-control': 'no-cache', 'pragma': 'no-cache' },
    body: qs.stringify(payload)
  })
    .then(response => response.json());
};

export const switchOrgToken = (ActionType, payload) => {
  return httpCall({
    method: HeaderActionApiMapping[ActionType].method,
    headers: {
      "Content-Type": "application/json"
    },
    params: payload,
    url: HeaderActionApiMapping[ActionType].url
  });
}

export const getManageProfileDataApi = (ActionType, payload) => {
  return httpCall({
    method: HeaderActionApiMapping[ActionType].method,
    headers: {
      "Content-Type": "application/json"
    },
    params: payload,
    url: HeaderActionApiMapping[ActionType].url
  });
}

export const updateProfilePhoneApi = (ActionType, payload ) => {
  payload = Object.assign({}, payload, { '__RequestVerificationToken': $('input[name="__RequestVerificationToken"]')[0].value || "" })
  return fetch(HeaderActionApiMapping[ActionType].url, {
    method: HeaderActionApiMapping[ActionType].method,
    credentials: "include",
    headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'cache-control': 'no-cache', 'pragma': 'no-cache' },
    body: qs.stringify(payload)
  })
    .then(response => response.json());
};

export const updateAUSettings  = (ActionType, payload ) => {
  payload = Object.assign({}, payload, { '__RequestVerificationToken': $('input[name="__RequestVerificationToken"]')[0].value || "" })
  return fetch(HeaderActionApiMapping[ActionType].url, {
    method: HeaderActionApiMapping[ActionType].method,
    credentials: "include",
    headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'cache-control': 'no-cache', 'pragma': 'no-cache' },
    body: qs.stringify(payload)
  })
    .then(response => response.json());
};

export const updateTimeZone = (ActionType, payload ) => {
  return httpFetch({
    url: HeaderActionApiMapping[ActionType].url,
    method: HeaderActionApiMapping[ActionType].method,
    credentials: "include",
    data: payload
  })
};

export const createUserLicense = (ActionType, payload ) => {
  return httpFetch({
    url: HeaderActionApiMapping[ActionType].url,
    method: HeaderActionApiMapping[ActionType].method,
    credentials: "include",
    data: {'userLicensesjson': JSON.stringify(payload) }
  })
};

export const updateUserLicense = (ActionType, payload ) => {
  return httpFetch({
    url: HeaderActionApiMapping[ActionType].url,
    method: HeaderActionApiMapping[ActionType].method,
    credentials: "include",
    data: {'userLicensejson': JSON.stringify(payload) }
  })
};

export const deleteUserLicense = (ActionType, payload ) => {
  return httpFetch({
    url: HeaderActionApiMapping[ActionType].url,
    method: HeaderActionApiMapping[ActionType].method,
    credentials: "include",
    data: {'state': payload }
  })
};

export const updateContactRelationshipType = (ActionType, payload) => {
  return httpFetch({
    url: HeaderActionApiMapping[ActionType].url,
    method: HeaderActionApiMapping[ActionType].method,
    credentials: "include",
    data: payload
  })
}

// Todos: New Golang APIs to be added below and old APIs to be removed above
// ------------------------------
export const getNotificationSettings = (ActionType) => {
  return httpCall({
    method: HeaderActionApiMapping[ActionType].method,
    headers: getAuthHeaders(),
    url: HeaderActionApiMapping[ActionType].url,
  }, true);
};

export const updateNotificationSettings = (ActionType, payload) => {
  return httpCall({
    method: HeaderActionApiMapping[ActionType].method,
    headers: getAuthHeaders(),
    data: payload,
    url: HeaderActionApiMapping[ActionType].url,
  }, true);
};

export const updateUser  = (payload ) => {
  const {url, method} = ep.updateUser;
  return httpCall({
    method: method,
    headers: getAuthHeaders(),
    data: payload,
    url: `${url}${payload.user.userId}`,
  });
};

export const fetchCreatePartyData = (ActionType, payload ) => {
  const apiPath = HeaderActionApiMapping[ActionType].url;
  return httpCall({
    method: HeaderActionApiMapping[ActionType].method,
    headers : getAuthHeaders(),
    params: payload,
    url: `/1.0${apiPath}`,
  });
};

export const fetchCarrierList = (ActionType, payload ) => {
  const apiPath = HeaderActionApiMapping[ActionType].url;
  return httpCall({
    method: HeaderActionApiMapping[ActionType].method,
    headers : getAuthHeaders(),
    params: payload,
    url: `/1.0${apiPath}`,
  });
};

export const fetchChangeLog = (ActionType, payload ) => {
  const apiPath = HeaderActionApiMapping[ActionType].url;
  return httpCall({
    method: HeaderActionApiMapping[ActionType].method,
    headers : getAuthHeaders(),
    params: payload,
    url: `/1.0${apiPath}`,
  });
};